import get from 'lodash/get';
import {
  OFFICE_VISIT_TYPE_CODE,
  VIRTUAL_VISIT_TYPE_CODE,
} from '../../../constants';

export const COLOR_MAP = {
  PATTENS_BLUE: '#ddf6ff',
  TITAN_WHITE: '#e9e6ff',
  CHIFFON: '#e1ffbd',
  SHALIMAR: '#fffebf',
  PEACH: '#ffe9b2',
  SILVER: '#afafaf',
};

const BORDER_COLOR_MAP = {
  [COLOR_MAP.PATTENS_BLUE]: '#1eb7eb',
  [COLOR_MAP.TITAN_WHITE]: '#8e88d3',
  [COLOR_MAP.CHIFFON]: '#95ca56',
  [COLOR_MAP.SHALIMAR]: '#f2ef42',
  [COLOR_MAP.PEACH]: '#f8cc5f',
  [COLOR_MAP.SILVER]: '#afafaf',
};

export const COLOR_LIST = [
  COLOR_MAP.PATTENS_BLUE,
  COLOR_MAP.TITAN_WHITE,
  COLOR_MAP.CHIFFON,
  COLOR_MAP.SHALIMAR,
  COLOR_MAP.PEACH,
];

export function getBorderAreaColor(targetColor) {
  return BORDER_COLOR_MAP[targetColor] || '#1eb7eb';
}

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

export function getRGBA(hexColor, opacity) {
  const rgb = hexToRgb(hexColor);

  if (!rgb) return null;

  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
}

export function getBackgroundAreaStyle(targetColor) {
  const color = BORDER_COLOR_MAP[targetColor];
  if (!color) return {};

  const rgb = hexToRgb(color);

  if (!rgb) return {};

  return { background: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.1)` };
}

export const APPOINTMENT_COLORS = {
  VIRTUAL: '#afecff',
  OFFICE: '#93edce',
  PENDING: '#ffd4cd',
  BLOCKED: '#eeeeee',
};

export function getAppointmentColor(appointment) {
  const type = get(appointment, 'visitType.code');
  const status = get(appointment, 'status.coreAppName');

  if (status === 'Pending') {
    return APPOINTMENT_COLORS.PENDING;
  }

  switch (type) {
    case OFFICE_VISIT_TYPE_CODE:
      return APPOINTMENT_COLORS.OFFICE;
    case VIRTUAL_VISIT_TYPE_CODE:
      return APPOINTMENT_COLORS.VIRTUAL;
    default:
      return 'lightgrey';
  }
}



// WEBPACK FOOTER //
// ./src/components/ProviderCalendar/utils/colorCodes.js